import _ from 'lodash'
import { Image, StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'
import HelperCart from 'utils/helper-cart'
import DataItem from 'components/atoms/DataItem'
import HelperString from 'utils/helper-string'
import i18n from 'utils/i18n'
import ThemedItem from 'components/atoms/ThemedItem'
import React from 'react'
import { ThemedValues } from 'styles/themed'
import { useSelector } from 'react-redux'
import { cartConstants } from 'services/redux/cart/constants'
import ThemedPressable from 'components/atoms/ThemedPressable'
import * as Animatable from 'react-native-animatable'
import HelperAlerts from 'utils/HelperAlerts'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'

const EmployeeExternal = ({ item, show, onPress, showEmail = true, showCompany = true, animationOnMount = false }) => {
	
	// KEEP THIS FOR THE RE-RENDER
	const _cartBookingCoworkers = useSelector( state => {
		return state.cart[cartConstants.BOOKING_COWORKERS][item?.guid];
	} );
	
	const _cartTimeslots = useSelector( state => {
		return state.cart[cartConstants.TIMESLOTS];
	} );
	
	let actionItem = null;
	let onPressExternalContact = null;
	
	const onExternalContactPress = ( external_contact ) => {
		if ( _.size( _cartTimeslots ) ) {
			HelperAlerts.alert(
				i18n.t( 'page.create.coworker.alerts.changing_coworker' ),
				null,
				[
					{
						text: i18n.t( 'buttons.cancel' ),
					},
					{
						text: i18n.t( 'buttons.ok' ),
						onPress: () => {
							HelperCart.resetCartTimeslots();
							HelperCart.toggleExternalContact( external_contact );
						}
					}
				]
			);
			return;
		}
		
		HelperCart.toggleExternalContact( external_contact );
	}
	
	switch( true ) {
		case _.isFunction( onPress ):
			onPressExternalContact = onPress.bind( this, item );
			break;
		
		case _.get( item, 'readOnly', false ):
			// no action button
			break;
		
		case _.get( item, 'deletable', false ):
			actionItem = (
				<ThemedPressable onPress={ onExternalContactPress.bind( this, item ) }>
					<Icon icon={ IconSystemConstants.TRASH } color={ colorList.RED.primary } />
				</ThemedPressable>
			);
			break;
		
		default:
			onPressExternalContact = onExternalContactPress.bind( this, item );
			actionItem = <Icon icon={ IconSystemConstants.CHECKBOX } key="icon_check" checked={ HelperCart.isExternalContactSelected( item ) } color={ colorList.ORANGE.primary } />;
			break;
	}
	
	const dataItems = [];
	if( _.get( item, 'company', null ) !== null && showCompany ) {
		dataItems.push(
			<DataItem
				key={ HelperString.hash('company') }
				identifier={ 'company' }
				content={ _.get( item, 'company', null ) }>
				
				{ i18n.t( 'company' ) }
			</DataItem>
		)
	}
	
	if( _.get( item, 'email', null ) !== null && showEmail ) {
		dataItems.push(
			<DataItem
				key={ HelperString.hash('email') }
				identifier={ 'email' }
				content={ _.get( item, 'email', null ) }>
				
				{ i18n.t( 'email' ) }
			</DataItem>
		)
	}
	
	if( _.isFunction( show ) ) {
		dataItems.push( show( item ) );
	}
	
	let photo = null;
	if( _.get( item, 'photo_url', null ) !== null ) {
		photo = (
			<Image
				source={ { uri: _.get( item, 'photo_url', null ) } }
				style={ styles.photo }
			/>
		);
	}
	
	const themedItem = (
		<ThemedItem
			key={ HelperString.hash( 'employee-external-item', item ) }
			identifier={ HelperString.hash( 'employee-external-item-id', item ) }
			accessoryLeft={ photo }
			accessoryLeftSize={ 45 }
			forceAccessoryLeftContainer={ true }
			title={ item.name }
			items={ dataItems }
			actionItem={ actionItem }
		/>
	);
	
	
	if( animationOnMount !== false ){
		if( animationOnMount === true ){
			animationOnMount = 'bounceIn';
		}
		return (
			<Animatable.View animation={ animationOnMount } key={ HelperString.hash( 'employee-external-item', item ) }>
				{ themedItem }
			</Animatable.View>
		);
	}
	
	
	if( onPressExternalContact !== null ) {
		return (
			<ThemedPressable
				key={ HelperString.hash( 'employee-external-item-click', item ) }
				onPress={ onPressExternalContact }>
				
				{ themedItem }
			</ThemedPressable>
		);
	}
	
	return themedItem;
}

const styles = StyleSheet.create({
	photo: {
		width: 45,
		height: 45,
		borderRadius: ThemedValues.borderRadius
	}
})

export default EmployeeExternal
